import styled from 'styled-components';
import { fonts, spacing } from 'ui/theme';

const withChart =
  '[col-icon] min-content [col-name] min-content [col-percent] auto [col-count] min-content';
const withoutChart = '[col-name] auto [col-count] min-content';

export const TableWrapper = styled.div`
  display: grid;
  grid-template-columns: ${withoutChart};
  align-items: stretch;
  font-family: ${fonts.sansSerif};
  background-color: #fff;
  margin: 0 -${spacing.base} 0 -${spacing.plusHalf};

  [data-has-meter-chart='true'] {
    grid-template-columns: ${withChart};
  }
`;
